import type { BlockContent } from 'mdast';

import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

import type { FromPMHandlers } from '../types';
import { convertBlockChildren } from '../utils';

export const panel = (node: PMNode, handlers: FromPMHandlers): BlockContent[] =>
	convertBlockChildren(node, handlers);
